import React, { useContext, useEffect, useState } from "react";
import {
  BackgroundDiv,
  BottomBtnArea,
  ClickEventBtn,
  ContentBody,
  DivSelectBoxTitle,
  HeaderTitle,
  InputText,
  NoticeText,
  SelectDivArea,
  SelectDivBody,
} from "./ReceiptStyle";

import { Button } from "../../../components";
import { AppContext } from "../../../components/AppProvider";
import { removeEmojis } from "../../../modules/utils/CheckLogic";
import { IC } from "../../../resources/Assets";

const InputSymptom = props => {
  const { userinfo, cfg, phonecfg } = useContext(AppContext);
  const { smptInfo, setSmptInfo, backStep } = props;
  const [smptText, setSmptText] = useState(smptInfo && smptInfo.symptomText);
  const [symtomps, setSymptoms] = useState();
  const [err, setErr] = useState(false);
  const submit = () => {
    setSmptInfo({
      symptomText: smptText,
    });

    if (backStep) {
      props.setPageIdx(1);
    } else {
      props.setPageIdx(3);
    }
  };

  const inputCheck = () => {
    removeEmojis();
  };

  useEffect(() => {
    props.setMsgState("symptom");
  }, []);

  const viewErr = () => {
    props.setViewMsgLayer(true);
    setErr(true);
  };

  return (
    <BackgroundDiv>
      <HeaderTitle>
        <div
          style={{ width: "40px", height: "40px" }}
          // onClick={() => props.setPageIdx(backStep ? 1 : 2)}
          onClick={() => props.setPageIdx(1)}>
          <img src={IC.etc.ICON_CHEVRON_LEFT} />
        </div>
        {/* <div>증상입력</div> */}
        <div>{props.hederTitle}</div>
        <div style={{ width: "40px", height: "40px" }}>
          {/* <img src={ArrowLeft} /> */}
        </div>
      </HeaderTitle>
      <ContentBody>
        <NoticeText>
          원활한 진료를 위해
          <br />
          증상을 입력해주세요
        </NoticeText>

        <SelectDivArea>
          <DivSelectBoxTitle>증상입력</DivSelectBoxTitle>
          <SelectDivBody err={err}>
            <InputText
              id="symptomText"
              placeholder="증상을 입력하세요"
              value={smptText}
              onChange={e => {
                setSmptText(removeEmojis(e.target));
                setErr(false);
              }}
              maxLength={150}
            />
          </SelectDivBody>
        </SelectDivArea>

        {/* <ClickEventBtnArea>
          {symtomps &&
            symtomps.map((m, i) => (
              <ClickBtnCpnt clickStatus={false} text={m.cdNm} code={m.cd} key={"smtm" + i} />
            ))}
        </ClickEventBtnArea> */}

        {/* <ImageDivArea>
          <ImageBtnAdd>
            <img src={Plus} />
          </ImageBtnAdd>
        </ImageDivArea> */}
      </ContentBody>
      {/* {smptText && smptText.trim().length > 0 && ( */}
      {/* <BottomBtn onClick={() => submit()}>{backStep ? "저장" : "저장 후 다음"}</BottomBtn> */}
      <BottomBtnArea>
        <Button
          severity="primary"
          disable={"off"}
          clickEvent={() =>
            smptText && smptText.trim().length > 0 ? submit() : viewErr()
          }>
          {backStep ? "저장" : "저장 후 다음"}
        </Button>
      </BottomBtnArea>
      {/* )} */}
    </BackgroundDiv>
  );
};

const ClickBtnCpnt = props => {
  const [clickStatus, setClickStatus] = useState(false);
  return (
    <ClickEventBtn clickStatus={clickStatus}>
      <input
        type="checkbox"
        name="symptoms"
        value={clickStatus ? props.code + "/Y" : props.code + "/N"}
        onClick={() => setClickStatus(!clickStatus)}
        hidden
      />
      {props.text}
    </ClickEventBtn>
  );
};

export default InputSymptom;
